import React from 'react';

export default function UnitIcon({
  width = 48,
  height = 48,
  fill = '#717172',
  className,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  width?: number | string;
  height?: number | string;
  fill?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_12200_18206)">
        <path
          d="M34.4758 47.9999V45.377H41.2832C43.4072 45.377 45.3418 43.4439 45.3418 41.3181V26.8292L45.154 26.6414H29.3553V24.0185H45.3418V6.71734C45.3418 4.59153 43.4072 2.65838 41.2832 2.65838H23.9854V26.6414H21.3628V18.8343L21.175 18.6465H15.9914V16.0236H21.3612V2.84457L21.1734 2.65676H6.686C4.56202 2.65676 2.62745 4.58991 2.62745 6.71572V16.022H10.6215V18.6449H2.81524L2.62745 18.8327V32.0102H17.3658V34.633H2.81524L2.62745 34.8208V41.3165C2.62745 43.4407 4.5604 45.3754 6.686 45.3754H21.1734L21.3612 45.1876V32.0102H23.9838V45.3754H29.229V47.9983H5.8118C3.1973 47.9983 0.0955143 44.676 0.00647555 42.0628L0 6.08591C0.297875 3.31248 2.23406 1.02476 4.90037 0.247614C17.1084 -0.249434 29.4184 0.181233 41.6637 0.0290424C44.5874 0.22009 46.9121 2.14838 47.7523 4.93153C48.2347 17.259 47.8478 29.6868 47.9482 42.0499C47.8867 44.6744 44.7833 47.9999 42.1558 47.9999H34.4742H34.4758Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_12200_18206">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
